<template>
  <Modal
    ref="addSingleVariantModalRef"
    :showIcon="false"
    :clickToClose="true"
    class="add-single-variant-model"
    :modalStyle="{ width: '460px', height: '318px' }"
  >
    <template v-slot:body style="gap: 24px;">
      <div class="header">
        <p class="title">Tekil Varyant Ekle</p>
      </div>
      
      <div class="input-area">
        <div class="input-with-title d-flex flex-column" v-for="attribute in variantAttributes">
          <p>{{ attribute.attributeName }}</p>
          <DropdownSelectable
            :disabled="!props.isCategorySelected"
            @selectedRadioItem="handleChanges($event, attribute.attributeName)"
            :dropItems="mapAttributeValues(attribute.attributeValues)"
            :notFoundText="`${attribute.attributeName} bulunamadı.`"
            isRadioGroup
            :singleItemTextLength="singleItemTextLength"
            :label="`${attribute.attributeName} Seç*`"
            :searchText="attribute.attributeName + ' Ara'"
            :isCustomValue="attribute.isCustomValue"
            customInputLabel="Yeni Değer Ekle"
          />
        </div>
      </div>

      <div class="button-container">
        <AppButton @click="closeModal" secondary md title="Vazgeç"></AppButton>
        <AppButton @click="submitChange" primary md title="Ekle"></AppButton>
      </div>
      
    </template>
  </Modal>
</template>

<script setup>
import { ref, defineExpose } from "vue";
import { Modal, AppButton, DropdownSelectable } from "@n11/so-ui-components";

const selectedChanges = ref([]);
const addSingleVariantModalRef = ref(null);

const props = defineProps({
  submitSingleVariant: {
    type: Function,
    required: false,
    default: value => value
  },
  isCategorySelected: {
    type: Boolean,
    required: true,
    default: false,
  },
  variantAttributes: {
    type: Array,
    required: true,
    default: []
  }
});

const emit = defineEmits(['submitSingleVariant']);

const mapAttributeValues = (values) => values.map(({ id, value }) => ({ id, name: value }))

const handleChanges = (e, attribute) => {
  const similarAttribute = selectedChanges.value.find((item) => item.name === attribute)
  if ( similarAttribute ) {
    const index = selectedChanges.value.findIndex((item) => item.name === attribute)
    selectedChanges.value.splice(index, 1, {name: attribute, value: e.name, id: e.id})
  } else {
    selectedChanges.value.push({
      name: attribute,
      value: e.name,
      id: e.id
    });
  }
};

const submitChange = () => {
  emit('submitSingleVariant', selectedChanges.value);

  selectedChanges.value = [];

  closeModal();
};

const openModal = () => {
  addSingleVariantModalRef.value?.openModal();
};

const closeModal = () => {
  addSingleVariantModalRef.value?.hiddenModal();
};

defineExpose({
  openModal,
});

</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';
@import '@/assets/styles/utilities.scss';

.header {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
}

.add-single-variant-model.modal-mask :deep(.modal-wrapper .modal-container) {
  position: relative;
  padding: 20px;
  height: auto !important;
  .modal-body {
    padding: 0px;
    height: 100%;
    overflow-y: visible;

    .content {
      gap: 24px;
    }
  }

  .modal-header.hasCloseIcon {
    position: absolute;
    top: 7px;
    right: 4px;
  }
}

.title {
  color: $colorN80;
  font-size: 20px;
  font-weight: 700;
  line-height: 26px;
  letter-spacing: -0.2px;
}

.text {
  color: $colorN80;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: -0.05px;
}

.input-area {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    gap: 20px;

    & > div {
      height: max-content;
    }

    .input-with-title {
      gap: 10px;
      font-size: 14px;
      line-height: 18px;
      font-weight: 600;
      color: $colorN80;
      text-align: left;
    }
  }

.button-container {
  display: flex;
  bottom: 20px;
  gap: 16px;
  width: 100%;
}
</style>
